export default "__VITE_ASSET__Co1TG_7M__"